module.exports = __webpack_public_path__ + "static/media/Resume.fa0251fe.pdf";